import { render, staticRenderFns } from "./questionbankUpload.vue?vue&type=template&id=7bd29bc8"
import script from "./questionbankUpload.vue?vue&type=script&lang=js"
export * from "./questionbankUpload.vue?vue&type=script&lang=js"
import style0 from "./questionbankUpload.vue?vue&type=style&index=0&id=7bd29bc8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports